
import { defineComponent, computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'
import { IarticleListType } from '@/store/page-index/types'
import { useRouter } from 'vue-router'
export default defineComponent({
  setup() {
    // 生成从minNum到maxNum的随机数
    type FooFnType = (minNum: number, maxNum: number) => number
    const randomNum = computed<FooFnType>(
      () => (minNum: number, maxNum: number) => {
        return Math.floor(Math.random() * maxNum + minNum)
      }
    )
    const store = useStore<IStoreType>()
    // 获取初始数据
    const articleList = computed(() => {
      return store.state.pageNoteModule.articleList
    })
    // 当前页数
    let num = ref<number>(0)
    // 最大页数
    let maxNum = ref<number>()
    // 全部数据列表
    let result: IarticleListType[][] = []
    // 当前页列表
    let article = ref<IarticleListType[]>([])
    // 优化数据
    let optimize = (lists: IarticleListType[]) => {
      result = []
      let list = lists
      list = list.sort((a, b) => Date.parse(b.time) - Date.parse(a.time))
      for (var i = 0; i < list.length; i += 5) {
        result.push(list.slice(i, i + 5))
      }
      article.value = result[num.value]
      maxNum.value = result.length
      // console.log(result, article)
    }
    // 分页
    let handleCurrentChange = (val: number) => {
      article.value = result[val - 1]
      window.scroll(0, 0)
    }
    watch(articleList, (n) => {
      optimize(n)
    })
    onMounted(() => {
      if (!articleList.value.length) {
        // 调用初始数据接口
        store.dispatch('pageNoteModule/onArticle')
      } else {
        optimize(articleList.value)
      }
    })
    // 跳转页面
    const router = useRouter()
    const onRouter = (_id: string) => {
      let routeUrl = router.resolve({
        path: `details`,
        query: { id: _id }
      })
      window.open(routeUrl.href, '_blank')
    }
    return {
      articleList,
      num,
      maxNum,
      article,
      handleCurrentChange,
      randomNum,
      onRouter
    }
  }
})
